import moment from 'moment';
import { TOOLTIP_LABEL_FORMAT } from '@utils/constants';
import { get } from 'lodash';
import { policyAction } from '@src/store/policies/schedule/utils';

const formatDate = ({ column, rowData }) => {
  const { dataKey } = column;
  return moment(rowData[dataKey]).format(TOOLTIP_LABEL_FORMAT);
};

const formatUsername = ({ rowData }) => {
  const { email = '', username = '' } = get(rowData, ['updatedBy', 'user']) || {};
  return email ? email : username;
};

const formatStatus = ({ rowData }) => {
  const { state } = rowData;
  return state ? state[0].toUpperCase() + state.slice(1) : 'Unknown';
};

const formatRecordForForm = (rowData) => {
  return rowData.type === policyAction.activate
    ? formatRecordForPolicyActivation(rowData)
    : formatRecordForPolicyReordering(rowData);
};

const formatRecordForPolicyActivation = (rowData) => {
  return {
    scheduleId: rowData.id,
    triggerAt: rowData.triggerAt,
    activationState: rowData.triggerAt === null ? 'now' : 'schedule',
    notes: rowData.notes,
    policies: rowData.policyList.map((p) => get(p, ['policy', 'id'])),
    visible: true,
    state: rowData.state,
    emailIds: JSON.parse(rowData.emailIds),
    modalType: rowData.type,
  };
};

const formatRecordForPolicyReordering = (rowData) => {
  return {
    scheduleId: rowData.id,
    triggerAt: rowData.triggerAt,
    activationState: rowData.triggerAt === null ? 'now' : 'schedule',
    notes: rowData.notes,
    visible: true,
    state: rowData.state,
    emailIds: JSON.parse(rowData.emailIds),
    modalType: rowData.type,
    order: JSON.parse(rowData.reorder.order),
  };
};

export { formatDate, formatStatus, formatRecordForForm, formatUsername };
